class Featuredcollections extends HTMLElement {
  constructor() {
    super();

    this.tabButtons = this.querySelectorAll('.nav-tab-item')
    this.baseUrl = this.dataset.collectionUrl

    Array.from(this.tabButtons).map(tab => {
      tab.addEventListener('click', this.onClickTab.bind(this))
    })
  }

  async onClickTab (event) {
    const { tabId, filter } = event.target.dataset
    let filteredProducts = false

    Array.from(this.tabButtons).map(tab => {
      if (tab.dataset.tabId === tabId) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    })

    for (const block of this.querySelectorAll('.product-grid-item')) {
      const filters = (block.dataset.filters || '').split('|')

      if (filters.includes(filter) || filter === 'all') {
        filteredProducts = true
        block.classList.remove('hidden')
      } else {
        block.classList.add('hidden')
      }
    }

    if (filteredProducts) {
      this.querySelector('.js-no-match').classList.add('hidden')
    } else {
      this.querySelector('.js-no-match').classList.remove('hidden')
    }

    if (filter === 'all') {
      Array.from(this.querySelectorAll('.js-promo-item')).map(promo => promo.classList.remove('hidden'))
    } else {
      Array.from(this.querySelectorAll('.js-promo-item')).map(promo => promo.classList.add('hidden'))
    }
  }
}

customElements.define('featured-collections', Featuredcollections);
